export default __webpack_public_path__ + "static/media/qweri-logo-white.7f841319.svg";